import { PostReactionsColorSet } from '@client/new/community/components/PostReactions';

export const ColorSets: Record<string, PostReactionsColorSet> = {
  Default: {
    chipBackground: 'bg-primary-150',
    chipFontColor: 'text-black',
    activeChipBorderColor: 'border-2 border-solid border-purple-1',
    addEmojiChipColor: 'text-purple-1',
  },
  Owner: {
    chipBackground: 'bg-blue-2',
    chipFontColor: 'text-white',
    activeChipBorderColor: 'border-2 border-solid border-white',
    addEmojiChipColor: 'text-white',
  },
  Thread: {
    chipBackground: 'bg-white',
    chipFontColor: 'text-black',
    activeChipBorderColor: 'border-2 border-solid border-purple-1',
    addEmojiChipColor: 'text-purple-1',
  },
};
